import React from 'react';
import { CircularProgress, type SxProps, type Theme } from '@mui/material';

const Loader = ({ sx }: { sx?: SxProps<Theme> }) => <CircularProgress sx={sx} />;

export default Loader;
